<template>
    <div class="d-flex align-items-center">
        <div class="score-bar-container global-theme">
            <div class="progress score-bar">
                <div
                    class="progress-bar bg-blue"
                    role="progressbar"
                    :style="scorePercentStyle"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    aria-label="Scenario score"
                ></div>
            </div>
        </div>
        <div class="text-center">
            <div class="medium font-weight-500 score-numbers ml-1">
                {{ score }}<span v-if="scoreMax">/</span>{{ scoreMax }}
            </div>
            <div class="text-secondary score-units">points</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SessionScoreBar",
    props: {
        score: {
            type: Number,
            required: false,
        },
        scoreMax: {
            type: Number,
            required: false,
        },
    },
    computed: {
        scoreValidated() {
            return this.score >= 0 ? this.score : 0
        },
        scorePercent() {
            let num = this.scoreValidated || 0
            let denom = this.scoreMax
            if (!denom) {
                return 0
            }
            return (num * 100) / denom
        },
        scorePercentStyle() {
            return {
                width: this.scorePercent + "%",
            }
        },
        scoreIsLow() {
            return this.scorePercent < 20
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.score-bar {
    height: 9px;
    background-color: #dde3ec !important;
    width: 130px;
    @media (min-width: $breakpoint-sm) {
        width: 150px;
    }
    @media (min-width: $breakpoint-3xl) {
        width: 180px;
    }
}

.score-bar-container {
    margin-right: 8px;
}

.score-numbers {
    min-width: 45px;
    line-height: 1;
}

.score-units {
    line-height: 1;
    padding-top: 2px;
    padding-left: 3px;
    font-size: 68%;
}
</style>